import Nullstack from 'nullstack';
export default function IconChessQueen({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chess-queen",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 16l2 -11l-4 4l-2 -5l-2 5l-4 -4l2 11"
  }), "   ", Nullstack.element("path", {
    d: "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "5",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "5",
    r: "1"
  }), " ");
}